module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bag2-9b5c20e0d0e92501afedf1084680beda.svg";